import { render, staticRenderFns } from "./EntrepotDocsListMobile.vue?vue&type=template&id=5f130d24&scoped=true&"
import script from "./EntrepotDocsListMobile.vue?vue&type=script&lang=js&"
export * from "./EntrepotDocsListMobile.vue?vue&type=script&lang=js&"
import style0 from "./EntrepotDocsListMobile.vue?vue&type=style&index=0&id=5f130d24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f130d24",
  null
  
)

export default component.exports